// src/redux/cartSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  carts: [],
};

const cartSlice = createSlice({
  name: "carts",
  initialState,
  reducers: {
    addToCart: (state, action) => {
      state.carts.push(action.payload);
    },
    fetchMyCarts: (state, action) => {
    },
  },
});

export const { addToCart, fetchMyCarts } = cartSlice.actions;
export default cartSlice.reducer;
